<template>
	<ui-slideover v-on:close="$emit('close')" title="Filter by">
		<slot>
			<div class="flex flex-col h-full divide-y divide-gray-200 border-t">
				<ui-filter-renderer
					:filter="adaptedFilter"
					:filter-options="filterOptions"
					:mapboxToken="mapboxToken"
					v-on:select-my-products="selectMyProducts()"
					v-on:filter-clear="clearFilters()"
					v-on:filter-close="callToApplyFilter()"
				/>
			</div>
		</slot>

		<template v-slot:custom>
			<div class="self-center grayscale" v-if="spinner">
				<!-- loading spinner-->
				<img
					class="animate-spin filter grayscale h-40 w-auto mx-auto"
					:src="logoUrl"
					alt="Loading"
				/>
			</div>
		</template>
	</ui-slideover>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		value: {
			type: Object,
		},
		mapboxToken: {
			type: String,
			required: true,
		},
	},
	data() {
		let locationModes = options.locationModeOptions,
			acl = this.$inertia.page.props.acl;
		if (!acl.can_fob_cif) {
			locationModes = locationModes.filter(
				(o) => !o.traderAndIndustryOnly === true
			);
		}
		let productGrades = new Array();
		Object.values(options.productGradeOptions)
			.flat()
			.forEach((o) => {
				if (o.group && o.default) {
					productGrades.push({ label: o.group, value: o.default });
				} else if (o.group) {
				} else {
					productGrades.push({ label: o.name, value: o.id });
				}
			});
		let productYears = options.harvestYearOptions.map(function (y) {
				return { label: y, value: y };
			}),
			dateType = [
				{
					label: this.__("At harvest"),
					value: "AT_HARVEST",
				},
				{
					label: this.__("Date range"),
					value: "MONTH",
				},
			],
			monthType = {
				month_from: null,
				month_to: null,
			},
			userFavoriteProductTypes =
				this.$inertia.page.props.user.favorite_product_types;
		locationModes = locationModes.map(function (o) {
			return { label: o.name, value: o.id };
		});
		let filterOptions = {
			productGrades: productGrades,
			productYears: productYears,
			dateType: dateType,
			monthType: monthType,
			locationModes: locationModes,
			showCity: true,
		};
		let filter = Object.assign({}, this.value);
		let adaptedFilter = this.adaptFilter(filter);
		return {
			spinner: false,
			filter: filter,
			filterOptions: filterOptions,
			userFavoriteProductTypes: userFavoriteProductTypes,
			adaptedFilter: adaptedFilter,
		};
	},
	computed: {
		logoUrl: () => window.baseUrl + "/images/cropspot-logo.svg",
	},
	watch: {
		adaptedFilter: {
			deep: true,
			immediate: true,
			handler: function (val) {
				this.reverseFilter(val);
			},
		},
		filter: {
			deep: true,
			handler: function (val) {
				this.$emit("input", val);
				this.adaptedFilter = this.adaptFilter(val);
			},
		},
	},
	methods: {
		selectMyProducts() {
			this.filter.product.grade = [];
			let productGradeOptions = this.$cropOptions.productGradeOptions;
			this.userFavoriteProductTypes
				.map((t) => productGradeOptions[t])
				.flat()
				.forEach((option) => {
					if (
						option.id.includes("WHEAT_B") &&
						option.default &&
						!this.filter.product.grade.includes("WHEAT_B")
					) {
						this.filter.product.grade.push("WHEAT_B");
					} else if (
						!option.id.includes("WHEAT_B") &&
						!this.filter.product.grade.includes(option.id)
					) {
						this.filter.product.grade.push(option.id);
					}
				});
		},
		callToApplyFilter() {
			this.spinner = true;
			this.$emit("apply");
		},
		clearFilters() {
			this.$emit("clear-filter");
		},
		adaptFilter(filter) {
			return {
				dateType: filter.date.type,
				locationModes: filter.location.mode,
				monthType: filter.date,
				productGrades: filter.product.grade,
				productYears: filter.product.harvest,
				type: filter.trade,
				location: filter.location,
			};
		},
		reverseFilter(val) {
			this.filter.date.type = val.dateType;
			this.filter.location.mode = val.locationModes;
			this.filter.date = val.monthType;
			this.filter.product.grade = val.productGrades;
			this.filter.product.harvest = val.productYears;
			this.filter.trade = val.type;
			this.filter.location = val.location;
		},
	},
};
</script>
